<script setup lang="ts">
import { useVModel } from '@vueuse/core'

interface Props {
  modelValue: string | null
  label?: string
  placeholder?: string
  error?: string
  required?: boolean
  disabled?: boolean
  rows?: number
  helperText?: string
  id?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: undefined,
  placeholder: undefined,
  error: undefined,
  required: false,
  disabled: false,
  rows: 5,
  helperText: undefined,
  id: () => `textarea-${Math.random().toString(36).substring(2, 11)}`
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const model = useVModel(props, 'modelValue', emit)
</script>

<template>
  <div class="space-y-1">
    <label
      v-if="label"
      :for="id"
      class="block text-sm font-medium text-gray-400"
    >
      {{ label }} <span v-if="required" class="text-red-500">*</span>
    </label>

    <textarea
      :id="id"
      v-model="model"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :rows="rows"
      class="w-full px-3 py-2 bg-base-300 border border-white/[0.06] rounded-lg text-gray-200 font-body text-sm outline-none placeholder:text-gray-500 focus:border-amber-400/30 focus:shadow-[0_0_24px_rgba(226,179,64,0.08)] transition-all"
      :class="{
        'border-red-500 focus:border-red-500': error,
      }"
      v-bind="$attrs"
    ></textarea>

    <p v-if="error" class="text-sm text-red-400">
      {{ error }}
    </p>
    <p v-else-if="helperText" class="text-sm text-gray-500 dark:text-gray-400">
      {{ helperText }}
    </p>
  </div>
</template>
